import { events } from "@constants/tracking";
import type { Plan } from "@memorang/types";
import { trackCustomEvent } from "analytics";
import { createCheckoutSession } from "api/commerce/product-service";

type Params = {
	selectedPlan: Plan;
	productId: string;
	redirectUrl: string;
	productName: string;
	productDescription: string;
	userId: string;
};
export const handleCreateCheckoutSession = async ({
	selectedPlan,
	productId,
	redirectUrl,
	productName,
	productDescription,
	userId,
}: Params): Promise<string> => {
	const {
		id: planId,
		amount,
		duration,
		interval,
		currency,
		name,
	} = selectedPlan;
	const handleTracking = (
		eventName: string,
		params?: Record<string, string | number>,
	) => {
		trackCustomEvent({
			eventName,
			bundleId: productId,
			bundleName: productName,
			...params,
		});
	};
	const checkoutParams = {
		productId,
		planId,
		description: productDescription,
		purchaseMode: "USER",
		successUrl: redirectUrl,
		failureUrl: redirectUrl,
		checkoutMode: "EMBED",
		quantity: 1,
		cancelUrl: redirectUrl,
	};

	const trackParams = {
		plan_id: planId,
		plan_duration: `${duration} ${interval}`,
		plan_price: amount,
		plan_currency: currency,
		plan_name: name,
	};

	handleTracking(events.paymentSubmitted, trackParams);
	const result = await createCheckoutSession({
		userId,
		payment: checkoutParams,
	});

	return result.clientSecret;
};
